import React, { useState } from 'react';
import { Col, Space, Typography, Card, Row } from 'antd';
import styled from 'styled-components';
import { COLORS, FONT_WEIGHTS, TEXT_SIZES } from '../../../utils/constants';
import { CourtDto } from '../../../types/types';
import DeleteModal from '../../shared/DeleteModal';
import { deleteCourtRequest } from '../../../api/requests/sports';
import { useSnackbar } from '../../../contexts/SnackbarContext/SnackbarProvider';
import {
  CourtsLabel,
  CourtsRow,
  Label,
  RatesRow,
  Value,
} from '../FacilitySport/FacilitySportCard';

interface SportOverviewProps {
  court: CourtDto;
  onEditCourt: (court: CourtDto) => void;
  onCourtDeletion: () => void;
  onEditSlot: (court: CourtDto) => void;
}

const CourtCard: React.FC<SportOverviewProps> = ({
  court,
  onEditCourt,
  onCourtDeletion,
  onEditSlot,
}) => {
  const snackbar = useSnackbar();
  const [isDeleteCourt, setIsDeleteCourt] = useState<boolean>(false);

  const handleDeleteCourt = async () => {
    try {
      const response = await deleteCourtRequest({
        facilitySportId: court.facilitySportId,
        courtId: court.courtId,
      });
      if (response?.isSuccess) {
        setIsDeleteCourt(false);
        onCourtDeletion();
        snackbar.success('Court deleted successfully');
      } else {
        snackbar.error(response?.error);
      }
    } catch (error: any) {
      snackbar.error(error?.Error || 'Error deleting court');
    }
  };

  const handleCancel = () => {
    setIsDeleteCourt(false);
  };
  return (
    <>
      <StyledCard>
        <StyledTitle>{court.courtName}</StyledTitle>
        <RatesRow>
          <Row>
            <Label>Weekday(₹/hr)</Label>
            <Value>
              {court.regularHourlyPrice ? court.regularHourlyPrice : '-'}
            </Value>
          </Row>
          <Row>
            <Label>Weekend(₹/hr)</Label>
            <Value>
              {court.weekendHourlyPrice ? court.weekendHourlyPrice : '-'}
            </Value>
          </Row>
        </RatesRow>

        <CourtsRow isSelected={false}>
          <CourtsLabel>Total Available slots</CourtsLabel>
          <Value>{court.availableSlots ? court.availableSlots : 0}</Value>
        </CourtsRow>

        <Col>
          <StyledSpaceWrapper>
            <StyledActionButton
              onClick={(e) => {
                e.stopPropagation();
                onEditCourt(court);
              }}
            >
              Edit Court
            </StyledActionButton>

            <StyledActionButton
              onClick={(e) => {
                e.stopPropagation();
                onEditSlot(court);
              }}
            >
              Manage Slots
            </StyledActionButton>

            <StyledActionButton
              onClick={(e) => {
                e.stopPropagation();
                setIsDeleteCourt(true);
              }}
            >
              Delete
            </StyledActionButton>
          </StyledSpaceWrapper>
        </Col>
      </StyledCard>
      {isDeleteCourt && (
        <DeleteModal
          open={isDeleteCourt}
          onConfirm={handleDeleteCourt}
          onCancel={handleCancel}
          moduleType="Court"
        />
      )}
    </>
  );
};

export default CourtCard;

const StyledCard = styled(Card)`
  border-radius: 16px;
  flex: 1;
  border: 1px solid ${COLORS.grey.secondary};
  cursor: pointer;
  .ant-card-body {
    padding: 14px 4px;
    border-radius: 16px;
  }
`;

const StyledTitle = styled(Typography.Text)`
  font-size: ${TEXT_SIZES.MD}px !important;
  font-weight: ${FONT_WEIGHTS.SEMIBOLD} !important;
  margin-bottom: 20px !important;
  color: ${COLORS.blue.primary} !important;
  padding: 0px 12px;
`;

const StyledActionButton = styled.span`
  color: ${COLORS.skyBlue.primary};
  cursor: pointer;
  margin-right: 15px;
  padding: 2px;
  border-radius: 6px;
  &:hover {
    background-color: ${COLORS.grey.secondaryLight};
  }
`;

const StyledSpaceWrapper = styled(Space)`
  &.ant-space {
    gap: 0px !important;
    padding: 0px 12px;
  }
`;
